import {
  isEmpty,
  isDefined,
  NotificationReadOutputSchema,
  type NotificationReadAllInput,
  type NotificationReadOutput,
} from '@terros/common'

export type NotificationReadAllResult = { updatedCount: number }

export async function readAllNotifications(
  input: NotificationReadAllInput,
  request: (input: NotificationReadAllInput) => Promise<NotificationReadOutput>
): Promise<NotificationReadAllResult> {
  let cursor = input.cursor
  let updatedCount = 0
  const cursors = new Set<string>()
  if (isDefined(cursor)) cursors.add(cursor)
  while (true) {
    // oxlint-disable-next-line no-await-in-loop
    const result = NotificationReadOutputSchema.parse(await request({ ...input, cursor }))
    if (!('hasMore' in result)) throw new Error('Expected an all-mode notification read response')
    updatedCount += result.updatedCount
    if (!result.hasMore) return { updatedCount }
    const next = result.nextCursor
    if (isEmpty(next) || cursors.has(next)) throw new Error('Notification continuation did not advance. Please retry.')
    cursors.add(next)
    cursor = next
  }
}
